var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeader6ShapeA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920.91 792.35s.33-212.36.33-260V9.9a9.89 9.89 0 00-9.89-9.9H11.14a9.9 9.9 0 00-9.9 9.9c0 167.35 4.91 335.48-1.24 502.71 173.36-31.81 350.84-40.49 525.77-20.27 191 22.08 372.12 92.54 550.91 159.55C1352.8 755.37 1625 821.73 1920.91 792.35z",
    fill: "#e4e8f1",
    opacity: 0.4
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIwIDEwODAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZTRlOGYxO29wYWNpdHk6MC40O308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xOTIwLjkxLDc5Mi4zNXMuMzMtMjEyLjM2LjMzLTI2MFY5LjlhOS44OSw5Ljg5LDAsMCwwLTkuODktOS45SDExLjE0YTkuOSw5LjksMCwwLDAtOS45LDkuOUMxLjI0LDE3Ny4yNSw2LjE1LDM0NS4zOCwwLDUxMi42MWMxNzMuMzYtMzEuODEsMzUwLjg0LTQwLjQ5LDUyNS43Ny0yMC4yNywxOTEsMjIuMDgsMzcyLjEyLDkyLjU0LDU1MC45MSwxNTkuNTVDMTM1Mi44LDc1NS4zNywxNjI1LDgyMS43MywxOTIwLjkxLDc5Mi4zNVoiLz48L3N2Zz4=";
export { SvgHeader6ShapeA as ReactComponent };